<template>
    <div>
      <a v-if="value !== 'NONE'" :href="value" target="_blank">
        {{ label }}
      </a>
      <span v-else>{{ label }}</span>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      value: {
        type: String,
        default: "NONE"
      },
      label: {
        type: String,
        required: true
      }
    }
  };
  </script>
  